import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEggheadComponent } from './simple-icons-egghead.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEggheadComponent ],
    exports:      [ SimpleIconsEggheadComponent ],
    bootstrap:    []
})
export class SimpleIconsEggheadModule {}
